import { useContext } from 'react';
import DonationFormContext from './DonationFormContext';

export const useDonationData = () => {
  const data = useContext(DonationFormContext) || null;

  const DEFAULT_PERIOD = data.options.defaultFrequency;
  const allAmountOptions = new Map();

  data.options.frequencies.forEach((frequency) => {
    const defaultPrice =
      frequency?.prices[1]?.price || frequency?.prices[0]?.price;

    const formatPriceToLocale = (price) => {
      let minimum = 2;

      if (price % 100 === 0) {
        minimum = 0;
      }

      return (price / 100).toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: minimum,
      });
    };

    const prices = frequency.prices.map(({ price }) => ({
      value: `${price / 100}`,
      label: formatPriceToLocale(price),
      isDefault: price === defaultPrice,
    }));

    prices.push({
      value: 'anders',
      label: 'Anders',
      isDefault: false,
    });

    allAmountOptions.set(frequency.name, prices);
  });

  const paymentTermOptions = [
    { text: 'Ik geef eenmalig', value: 'oneTime' },
    { text: 'Ik geef maandelijks', value: 'monthly' },
    { text: 'Ik geef jaarlijks', value: 'annual' },
  ];

  return {
    allAmountOptions,
    paymentTermOptions,
    DEFAULT_PERIOD,
  };
};
